<template>
  <div id="process-dialog">
    <el-dialog
      title="节点命名"
      :visible.sync="dialog"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="35%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="JOB名称" prop="name" required>
          <el-input
            autofocus
            v-model="ruleForm.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="formReset('ruleForm')"
          >取 消</el-button
        >
        <el-button
          :loading="loading"
          type="primary"
          @click="submitForm('ruleForm')"
          >创 建</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { UUID } from "@/utils/index.js";

export default {
  name: "process-dialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    selectNode: {
      type: Object
    },
    nodeName: {
      type: Array
    }
  },
  data() {
    const jobName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入Job名称"));
      } else if (value.length > 20) {
        callback(new Error("Job名称最大长度为20位字符"));
      } else {
        if (!this.nodeName.find(node => node.jobName == value)) {
          callback();
        } else {
          callback(new Error("Job名重复"));
        }
      }
    };
    return {
      loading: false,
      ruleForm: {
        name: ""
      },
      rules: {
        name: [
          {
            validator: jobName,
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    formReset(form) {
      this.$refs[form].resetFields();
      this.$emit("update:dialog", false);
    },
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.setNode();
        }
      });
    },
    setNode() {
      this.loading = true;
      this.$http
        .get(
          `/gavial/v1/plugin/view/detail?name=${this.selectNode.pkgName}&version=${this.selectNode.pkgVersion}`
        )
        .then(res => {
          this.$emit("addNode", {
            nodeId: UUID(20),
            jobName: this.ruleForm.name,
            pkgId: res.data.data.pkgId,
            name: this.selectNode.pkgName,
            version: this.selectNode.pkgVersion,
            jobParams: res.data.data.params.paramSchemas,
            verOptions: this.selectNode.versions
          });
          this.formReset("ruleForm");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
